import { PropsWithChildren, ReactNode } from 'react';
import { mix } from 'polished';
import { Box, BoxProps, Flex } from 'reflexbox';
import styled, { ThemeColors } from 'styled-components';

import { Paragraph, Subheading } from './Text';

const Element = styled(Flex)<{ $color: keyof ThemeColors }>`
	background-color: ${(props) => mix(0.1, props.theme.colors[props.$color], 'white')};
	border-radius: 6px;
	color: ${(props) => mix(0.75, props.theme.colors[props.$color], 'black')};

	${Paragraph}, ${Subheading} {
		color: ${(props) => mix(0.75, props.theme.colors[props.$color], 'black')};
	}

	svg path {
		fill: ${(props) => mix(0.75, props.theme.colors[props.$color], 'black')};
	}
`;

export type CalloutProps = PropsWithChildren<
	{
		color: keyof ThemeColors;
		icon?: ReactNode;
		title?: string;
		description?: string;
		small?: boolean;
	} & BoxProps
>;

export function Callout({
	color,
	icon,
	title,
	description,
	small,
	children,
	...rest
}: CalloutProps) {
	return (
		<Element p={small ? 1 : 3} $color={color} {...rest}>
			{icon && (
				<Box width="24px" mr={2} flexGrow={0} flexShrink={0}>
					{icon}
				</Box>
			)}
			{(title || description) && (
				<Box>
					<Subheading>{title}</Subheading>
					<Paragraph>{description}</Paragraph>
				</Box>
			)}
			{typeof children === 'string' ? <Paragraph>{children}</Paragraph> : children}
		</Element>
	);
}
